import { DocumentsCategoriesTabsTypes } from '../types';
import {
  IconLeft,
  IconRight,
} from '../../../../../../baseella-ui-components/src';

import cn from '../styles.module.css';

const DocumentsCategoriesTabs = ({
  withLeftButton,
  onScrollButton,
  scrollWrapper,
  selectedCategory,
  onCategoryClick,
  prevSearchText,
  searchText,
  prevStatuses,
  selectedStatuses,
  allowedCategories,
  stats,
  withScrollButton,
}: DocumentsCategoriesTabsTypes) => (
  <div className={cn.documentsCategoriesContent}>
    {withLeftButton && (
      <button
        type="button"
        aria-label="Scroll left"
        className={`${cn.scrollRight} ${cn.scrollLeft}`}
        onClick={() => onScrollButton('left')}
      >
        <IconLeft />
      </button>
    )}
    <div className={cn.documentsCategoriesWrapper} ref={scrollWrapper}>
      <div className={cn.documentsCategories}>
        <button
          type="button"
          className={`${cn.documentCategory} ${
            selectedCategory?.id === 'all' ? cn.active : ''
          }`}
          id="all"
          onClick={() =>
            onCategoryClick(
              { id: 'all', category: 'all' },
              Boolean(
                !!(prevSearchText && !searchText) ||
                (prevStatuses?.length && !selectedStatuses?.length),
              ),
            )
          }
        >
          All documents
        </button>
        {allowedCategories?.map((item) => (
          <button
            type="button"
            className={`${cn.documentCategory} ${
              selectedCategory?.id === item.id ? cn.active : ''
            } ${
              stats &&
              !stats.find((stat) => stat.documentCategoryId === item.id)
                ? cn.withoutDocs
                : ''
            }`}
            id={item.id}
            key={item.id}
            onClick={() =>
              onCategoryClick(
                item as { id: string; category: string },
                Boolean(
                  !!(prevSearchText && !searchText) ||
                  (prevStatuses?.length && !selectedStatuses?.length),
                ),
              )
            }
          >
            {`${
              item.name.includes('Add other document')
                ? 'Other documents'
                : item.name
            } ${
              stats?.find((stat) => stat.documentCategoryId === item.id)
                ? `(${
                    stats?.find((stat) => stat.documentCategoryId === item.id)
                      ?.count
                  })`
                : ''
            }`}
          </button>
        ))}
      </div>
    </div>
    {withScrollButton && (
      <button
        type="button"
        aria-label="Scroll right"
        className={cn.scrollRight}
        onClick={() => onScrollButton('right')}
      >
        <IconRight />
      </button>
    )}
  </div>
);

export default DocumentsCategoriesTabs;
